import { createTheme } from "@mui/material";
import {
  common,
  blue,
  green,
  grey,
  amber,
  red,
  indigo,
} from "@mui/material/colors";

import "@fontsource/pretendard/300.css";
import "@fontsource/pretendard/400.css";
import "@fontsource/pretendard/500.css";
import "@fontsource/pretendard/700.css";

export default createTheme({
  palette: {
    primary: {
      main: indigo[700],
      light: indigo[500],
      dark: indigo[900],
      contrastText: common.white,
    },
    secondary: {
      main: common.white,
      light: common.white,
      dark: "#f5f5f5",
      contrastText: grey[900], // 흰색 배경에는 어두운 텍스트
    },
    error: {
      main: red[600],
      light: red[400],
      dark: red[800],
      contrastText: common.white,
    },
    warning: {
      main: amber[600],
      light: amber[400],
      dark: amber[800],
      contrastText: "#000000",
    },
    info: {
      main: blue[600],
      light: blue[400],
      dark: blue[800],
      contrastText: common.white,
    },
    success: {
      main: green[600],
      light: green[400],
      dark: green[800],
      contrastText: common.white,
    },
    background: {
      default: common.white,
      paper: common.white,
    },
    text: {
      primary: grey[900],
      secondary: grey[700],
      disabled: grey[500],
    },
    action: {
      active: grey[600],
      hover: grey[100],
      selected: grey[200],
      disabled: grey[300],
      disabledBackground: grey[200],
      focus: grey[300],
    },
    divider: grey[200],
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          lineHeight: "normal",
          padding: "8px 16px",
          color: "inherit",
          height: 48,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          [`&.MuiTableRow-hover:hover`]: {
            backgroundColor: "#F3F6F9",
          },
          [`&.Mui-selected`]: {
            backgroundColor: "#F0F7FF",
            color: "#0072E5",
          },
          [`&.Mui-selected:hover`]: {
            backgroundColor: "rgba(0, 127, 255, 0.12)",
            color: "inherit",
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: grey[100],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        // root: ({ ownerState }) => ({
        //   ...{
        //     borderRadius: '8px',
        //   },
        // }),
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontWeight: 500,
          marginBottom: 4,
          ["&.Mui-focused"]: {
            color: "#757575",
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          [`&.Mui-selected`]: {
            backgroundColor: "#F0F7FF",
            color: "#0072E5",
          },
          [`&.Mui-selected:hover`]: {
            backgroundColor: "rgba(0, 127, 255, 0.12)",
            color: "inherit",
          },
          [`&:hover`]: {
            backgroundColor: "#F3F6F9",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...((ownerState.variant === "body1" ||
            ownerState.variant === "body2") && {
            fontSize: "0.875rem",
            fontWeight: 600,
          }),
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontWeight: 500,
          [`& .MuiInputBase-input`]: {
            padding: "10px 14px",
          },
          [`& .Mui-disabled`]: {
            backgroundColor: grey[100],
          },
          [`& .Mui-error .MuiOutlinedInput-notchedOutline`]: {
            borderColor: `${red[400]} !important`,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontWeight: 500,
          [`& .MuiInputBase-input`]: {
            padding: "10px 14px",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontWeight: 500,
          [`& .MuiInputBase-input`]: {
            padding: "10px 14px",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        multiline: {
          padding: `0 !important`,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 700,
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          [`&.Mui-expanded`]: {
            margin: 0,
          },
          [`&:before`]: {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: "0 1rem",
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontWeight: 600,
          [`&.Mui-expanded`]: {
            minHeight: 48,
          },
        },
        content: {
          [`&.Mui-expanded`]: {
            margin: 0,
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          cursor: "pointer",
          textDecoration: "none",
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '"Pretendard Variable"',
      "Pretendard",
      "-apple-system",
      "BlinkMacSystemFont",
      "system-ui",
      "Roboto",
      '"Helvetica Neue"',
      '"Segoe UI"',
      '"Apple SD Gothic Neo"',
      '"Noto Sans KR"',
      '"Malgun Gothic"',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      "sans-serif",
    ].join(","),
  },
});
